<template>
  <div>
    <!-- 外层对话框 -->
    <el-dialog title="规则奖励" width="80%" :visible.sync="outerVisible" :close-on-click-modal="false">
      <!-- 内层对话框 -->
      <el-dialog width="30%" :title="key ? '编辑规则奖励' : '添加规则奖励'" :visible.sync="innerVisible" append-to-body :close-on-click-modal="false"
        :before-close="handleClose">
        <el-form :model="tableForm" ref="tableForm" :rules="rules">
          <el-form-item label="数量" prop="needNum" label-width="100px" v-if="type == 0">
            <el-input type="number" :disabled="disabled" v-model.number="tableForm.needNum" placeholder="满足数量"
              clearable> </el-input>
          </el-form-item>
          <el-form-item label="金额" prop="needMoney" label-width="100px" v-if="type == 1">
            <el-input type="number" :disabled="disabled" v-model.number="tableForm.needMoney" placeholder="满足金额"
              clearable> </el-input>
          </el-form-item>
          <el-form-item label="服务商" prop="fmoney" label-width="100px">
            <el-input type="number" v-model.number="tableForm.fmoney" placeholder="金额" clearable> </el-input>
          </el-form-item>
          <el-form-item label="一星合伙人" prop="yihmoney" label-width="100px">
            <el-input type="number" v-model.number="tableForm.yihmoney" placeholder="金额" clearable> </el-input>
          </el-form-item>
          <el-form-item label="二星合伙人" prop="erhmoney" label-width="100px">
            <el-input type="number" v-model.number="tableForm.erhmoney" placeholder="金额" clearable> </el-input>
          </el-form-item>
          <el-form-item label="三星合伙人" prop="sahmoney" label-width="100px">
            <el-input type="number" v-model.number="tableForm.sahmoney" placeholder="金额" clearable> </el-input>
          </el-form-item>
          <el-form-item label="四星合伙人" prop="sihmoney" label-width="100px">
            <el-input type="number" v-model.number="tableForm.sihmoney" placeholder="金额" clearable> </el-input>
          </el-form-item>
          <el-form-item label="五星合伙人" prop="wuhmoney" label-width="100px">
            <el-input type="number" v-model.number="tableForm.wuhmoney" placeholder="金额" clearable> </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit()">确定</el-button>
        </div>
      </el-dialog>
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" @click="openInnerDialog(0)">
            添加规则奖励
          </el-button>
        </el-form-item>
      </el-form>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" border stripe>
        <el-table-column align="center" :label="type ? '金额' : '数量'"
          :prop="type ? 'needMoney' : 'needNum'"></el-table-column>
        <el-table-column align="center" label="服务商（单位：元）" prop="fmoney"></el-table-column>
        <el-table-column align="center" label="一星合伙人（单位：元）" prop="yihmoney"></el-table-column>
        <el-table-column align="center" label="二星合伙人（单位：元）" prop="erhmoney"></el-table-column>
        <el-table-column align="center" label="三星合伙人（单位：元）" prop="sahmoney"></el-table-column>
        <el-table-column align="center" label="四星合伙人（单位：元）" prop="sihmoney"></el-table-column>
        <el-table-column align="center" label="五星合伙人（单位：元）" prop="wuhmoney"></el-table-column>
        <el-table-column align="center" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button class="edit-btn" type="primary" plain size="mini"
              @click="openInnerDialog(1, scope.row)">编辑</el-button>
            <el-popconfirm title="确定要删除这行数据吗？" @confirm="del(scope.row)">
              <el-button type="danger" size="mini" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="outerVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      outerVisible: false,
      innerVisible: false,
      // 规则类型标识
      type: 0,
      //添加或编辑标识
      key: 0,
      // 表格请求所用id
      id: '',
      disabled: false,
      tableData: [],
      tableForm: {
        needNum: "",
        needMoney: "",
        fmoney: "",
        yihmoney: "",
        erhmoney: "",
        sahmoney: "",
        sihmoney: "",
        wuhmoney: "",
      },
      rules: {
        needNum: [
          { required: false, message: "请输入满足数量", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" },
        ],
        needMoney: [
          { required: false, message: "请输入满足金额", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        fmoney: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        yihmoney: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        erhmoney: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        sahmoney: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        sihmoney: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        wuhmoney: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 打开外层对话框
    openOuterDialog(id, type) {
      this.type = type;
      this.id = id
      this.$axios.get(`/admin/ruleDetail/list?awardId=${id}`).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.tableData = res.data;
          this.outerVisible = true;
        }
      })
    },
    //更新
    reNew(id) {
      this.$axios.get(`/admin/ruleDetail/list?awardId=${id}`).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.tableData = res.data;
          this.handleClose()
        }
      })
    },
    // 打开内层对话框
    openInnerDialog(key, row) {
      this.key = key;
      this.innerVisible = true;
      console.log(key, row);
      if (row) {
        this.disabled = true
        this.tableForm = row
      }
    },
    // 关闭内层对话框前做什么
    handleClose() {
      this.$refs.tableForm.resetFields();
      this.innerVisible = false;
      this.disabled = false
      this.tableForm = {
        awardId: "",
        needNum: "",
        needMoney: "",
        fmoney: "",
        yihmoney: "",
        erhmoney: "",
        sahmoney: "",
        sihmoney: "",
        wuhmoney: "",
      }
    },

    submit() {
      this.$refs.tableForm.validate((valid) => {
        if (valid) {
          if (this.key == 0) {
            // 添加
            this.tableForm.awardId = this.id
            console.log('444', this.tableForm);
            this.$axios.post('/admin/ruleDetail/add', this.tableForm).then((res) => {
              if (res.code == 0) {
                console.log('555', res);
                this.reNew(this.id)
                this.$message({
                  showClose: true,
                  message: '恭喜你，操作成功',
                  type: 'success',
                })
              }
            })
          } else if (this.key == 1) {
            // 编辑
            console.log('555', this.tableForm);
            this.$axios.post('/admin/ruleDetail/update', this.tableForm).then((res) => {
              if (res.code == 0) {
                console.log('666', res);
                this.reNew(this.id)
                this.$message({
                  showClose: true,
                  message: '恭喜你，操作成功',
                  type: 'success',
                })
              }
            })
          }
        }
      })
    },
    // 删除
    del(row) {
      let obj = {}
      obj.awardId = row.awardId
      if (row.needNum) {
        obj.needNum = row.needNum
      }
      if (row.needMoney) {
        obj.needMoney = row.needMoney
      }
      this.$axios.post(`/admin/ruleDetail/delete`, obj).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.reNew(this.id)
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.edit-btn {
  margin-right: 10px;
}
</style>